module.exports = __webpack_public_path__ + "click.mp3";